<div class="dropdown-container">
    <div class="dropdown">
        <div class="dropdown-header" (click)="toggleDropdown()" id="dropDown">
            <div class="dropdown-value">
                <div class="permanent-label" *ngIf="permanentLabel">{{ permanentLabel }}</div>
                <div [ngClass]="categorySelected ? 'category-placeholder' : 'placeholder'">{{ selectedOption || placeHolder }}</div>
            </div>
            <span class="arrow" [class.open]="isOpen"><img src="/assets/icons/Arrow.svg" alt="caret" /></span>
        </div>
        <div class="dropdown-list" *ngIf="isOpen">
            <div class="dropdown-item" [ngClass]="{'selected': option.name === selectedOption}" *ngFor="let option of options" (click)="selectOption(option)">
                {{ option.name }}
            </div>
        </div>
    </div>
</div>